export default __webpack_public_path__ + "static/media/whatsapp-icon.2593a8ae.png";